import type { ApiResponse } from "../../../server/api/client";
import { ApiService } from "../../../server/api/client";
import type { UnlayerAccount } from "../types/unlayer-account";

export class EmailContentService extends ApiService {
  module = "email-content";

  async account(): Promise<ApiResponse<UnlayerAccount>> {
    return await this.get("account");
  }
}
